import { Priority } from '@nlapps/editor-client-web';

const SPELLING_TYPE = 'spelling';
const GRAMMAR_TYPE = 'grammar';
const REFINEMENTS_TYPE = 'refinements';

export function convertPriorityToTypeString(priority: Priority): string {
    switch (priority) {
        case Priority.Low:
            return REFINEMENTS_TYPE;
        case Priority.Medium:
            return GRAMMAR_TYPE;
        case Priority.High:
            return SPELLING_TYPE;
    }

    return 'callout_unknown';
}
